// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__Bf4fC","controls":"Carousel_controls__iZ9hO","control":"Carousel_control__ce8yh","indicator":"Carousel_indicator__3qY8S"};